import { request } from "@/api/request"

export function fetchCourseConsumedList(payload = {}) {
  return request.post("/mgm-crm-api/course-consumed/list", payload).then(r => r.data)
}

export function fetchCourseConsumedSummary(payload = {}) {
  return request.post("/mgm-crm-api/course-consumed/summary", payload).then(r => r.data)
}

export function createCourseConsumed(payload = {}) {
  return request.post("/mgm-crm-api/course-consumed/create", payload).then(r => r.data)
}

export function updateCourseConsumed(payload = {}) {
  return request.post("/mgm-crm-api/course-consumed/update", payload).then(r => r.data)
}

/** 查询学生课包剩余课时 */
export function fetchStudentPackageRemain(payload = {}) {
  return request.post("/mgm-crm-api/course-consumed/student-package-remain", payload).then(r => r.data)
}

export function deleteCourseConsumed(id) {
  return request.post(`/mgm-crm-api/course-consumed/delete/${id}`, {}).then(r => r.data)
}

/** 设置课包剩余课时 */
export function setCoursePackageRemain(payload = {}) {
  return request.post("/mgm-crm-api/course-consumed/set-remain", payload).then(r => r.data)
}
